import { motion } from 'framer-motion';

import { Icon } from '@/new/components/icon';

export function ComposingMessage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      className="mx-auto my-4 flex max-w-3xl items-center gap-2 rounded-lg border bg-white px-3 py-2.5 text-xs text-gray-600"
    >
      <span className="flex items-center gap-2">
        <Icon className="lucide--loader animate-spin text-teal-500 ease-in-out" />
        <span>Thinking deeply. It may take longer to generate a response.</span>
      </span>
    </motion.div>
  );
}
